<script>
    import ImageResponsive from "@/components/ImageResponsive";

    export default {
        name: "HomeAbout",
        components: { ImageResponsive },
        props: {
            text: {
                type: String,
                default: "",
            },
        },
    };
</script>

<template>
    <section class="home-about">
        <h2 class="page-title">Биван — комфортный отдых всегда и везде</h2>
        <div class="home-about__inner">
            <div class="home-about__image">
                <image-responsive
                    desktop-webp="/static/bivan/assets/home/about.webp"
                    desktop="/static/bivan/assets/home/about.png"
                ></image-responsive>
            </div>
            <div class="home-about__text" v-html="text"></div>
        </div>
    </section>
</template>

<style lang="scss">
    .home-about__inner {
        @include bp($bp-desktop-sm) {
            display: flex;
            justify-content: center;
            padding-top: 8px;
        }
    }

    .home-about__image {
        display: none;
        @include bp($bp-desktop-sm) {
            flex-shrink: 0;
            flex-basis: 460px;
            display: block;
            max-width: 460px;
            margin-right: 50px;
        }
    }

    .home-about__text {
        font-size: 14px;
        font-weight: 300;
        line-height: 28px;
        text-align: center;
        p {
            &:first-child {
                margin-bottom: 16px;
            }
        }
        @include bp($bp-desktop-sm) {
            padding-top: 24px;
            font-size: 18px;
            line-height: 38px;
            text-align: left;
            p {
                &:first-child {
                    margin-bottom: 20px;
                }
            }
        }
    }
</style>
